export const ARTICLE_SERIES_INDEX = "article_series_index";
export const ARTICLE_INDEX = "article_index";
export const ARTICLE_SERIES_ARTICLES_INDEX = "article_series_articles_index";
export const USER_INDEX = "user_index";
export const ROLEPLAY_INDEX = "roleplay_index";
export const SCENARIO_INDEX = "scenario_index";
export const PROGRAM_INDEX = "program_index";
export const COACH_INDEX = "agent_profile_index";
export const WORKSPACE_GROUP_INDEX = "workspace_group_index";
